import React, { useCallback, useEffect, useState } from 'react';
import Stat from '@components/common/Stat';
import { DatePickerWrapper, RightSection, Row } from './styled';
import PageButtons from '../PageButtons';
import { Spin } from 'antd';
import moment from 'moment';
import { DatePickerModifier } from '../DatePickerModifier';

interface Interval {
  from: string;
  to: string;
  shortcut: string;
}

interface IProps {
  alerts: any[];
  status: string;
  setStatus: (status: string) => void;
  isFetching: boolean;
  interval: Interval;
  onApplyInterval: (interval: Interval) => void;
}

const hasEvents = (a: any) => (a.events || []).length > 0;

const buildStatItems = (alerts: any[]) => [
  { key: 'all', title: 'Total Alert Configs', value: `${alerts.length}` },
  {
    key: 'enabled',
    title: 'Enabled Alert Configs',
    value: `${alerts.filter((a) => a.state).length}`,
  },
  {
    key: 'disabled',
    title: 'Disabled Alert Configs',
    value: `${alerts.filter((a) => !a.state).length}`,
  },
  { key: 'triggered', title: 'Triggered Alerts', value: `${alerts.filter(hasEvents).length}` },
];

const Toggles = ({
  alerts,
  setStatus,
  status,
  isFetching = false,
  interval,
  onApplyInterval,
}: IProps) => {
  const { from, to, shortcut } = interval;
  const [currentInterval, setCurrentInterval] = useState([from, to, shortcut]);

  useEffect(() => {
    setCurrentInterval([from, to, shortcut]);
  }, [from, to, shortcut]);

  const onChangeDatePicker = useCallback(({ interval: updatedInterval, selectedShortcut }) => {
    setCurrentInterval([...updatedInterval, selectedShortcut]);
  }, []);

  const onApplyDatePicker = () => {
    onApplyInterval({
      from: moment(currentInterval[0]).format(),
      to: moment(currentInterval[1]).format(),
      shortcut: currentInterval[2],
    });
  };

  const onCancelDatePicker = () => setCurrentInterval([from, to, shortcut]);

  const items = buildStatItems(alerts);

  const onClick = (key) => {
    setStatus(key);
  };

  return (
    <Row>
      <Stat items={items} onClick={onClick} selected={status} />
      <div style={{ padding: 10 }}>
        <Spin tip="Refreshing alerts..." size="small" spinning={isFetching} />
      </div>
      <RightSection>
        <DatePickerWrapper>
          <DatePickerModifier
            durationAllowed={3}
            interval={[moment(from), moment(to)]}
            defaultShortcut={shortcut}
            className="manual-alerts-date-picker"
            onApply={onApplyDatePicker}
            onCancel={onCancelDatePicker}
            onChange={onChangeDatePicker}
          />
        </DatePickerWrapper>
        <PageButtons />
      </RightSection>
    </Row>
  );
};

export default Toggles;
